export const routes = {
  home: "/",
  discover: "/discover",
  impact: "/impact",
  vote: "/vote",
  termOfUse: "/terms-of-use",
  privacyPolicy: "/privacy-policy",
  cookiesPolicy: "/cookies-policy",
  contact: "/contact",
};

export const bookPageUrl = (slug: string, referer?: string) =>
  `/book/${slug.trim()}${referer ? `?referer=${referer}` : ""}`;

export const seriesPageUrl = (slug: string, referer?: string) =>
  `/serie/${slug.trim()}${referer ? `?referer=${referer}` : ""}`;
